import { getDocs, collection, query, where, limit } from 'firebase/firestore';
import useHaversine from "@/composables/calcDistanceHav";
import { db } from "@/firebase/config";

export default function useLocationsWithinDistance() {
    const { haversineDistance } = useHaversine();

    const fetchLocations = async (lat, lon, maxDist) => {
        // console.log('fetching locations now')
        // const queryLocations = await getDocs(collection(db, "locations"));

        const locationsCollectionRef = collection(db, "locations");
        const locationsQuery = query(locationsCollectionRef, where("hidden", "==", false));
        const queryLocations = await getDocs(locationsQuery);

        const results = [];

        queryLocations.forEach((doc) => {
            const data = doc.data();
            const distance = haversineDistance(lat, lon, data.lat, data.lon);
            // console.log('distance is: ', distance, ' to ', data.name)

            if (distance <= maxDist) {
                results.push({
                    id: doc.id,  // Include the document ID here
                    ...data,
                    distance
                });
            }
        });
        results.sort((a, b) => a.distance - b.distance);
        return results; // return the results directly
    }

    return { fetchLocations };
}
